// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VForm,
  VDivider,
  VTextField,
  VSelect,
  VSubheader,
  VProgressCircular
} from 'vuetify'
import VueRecaptcha from 'vue-recaptcha';
import VueQrcodeReader from 'vue-qrcode-reader'
import '../node_modules/vuetify/src/stylus/app.styl'
import './components/shared/mixins';
import Notifications from 'vue-notification';
import VueResource from 'vue-resource';

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCard,
    VForm,
    VDivider,
    VTextField,
    VSelect,
    VSubheader,
    VProgressCircular
  },
  theme: {
    primary: '#4286f4',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(Notifications);
Vue.use(VueQrcodeReader);

Vue.http.options.root = process.env.API_URL || 'http://localhost:8080';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js